import { Button, Card, CardContent } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import DiamondIcon from '@/shared/assets/diamond-icon.svg?react';

type Props = {
  onClick: () => void;
  className?: string;
};

const AssetsListEmptyState = ({ className, onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <Card className={className}>
      <CardContent className="flex flex-col items-center justify-end pb-[3.2rem] gap-[2.4rem] h-[30rem] max-w-[42rem] self-center">
        <DiamondIcon className="w-[5.6rem]" />
        <div className="flex flex-col items-center justify-center gap-[0.8rem]">
          <span className="headline4">
            {t('personalAccount.accountsSection.emptyStateTitle')}
          </span>
          <p className="p4 text-center text-secondary">
            {t('personalAccount.accountsSection.emptyStateDescription')}
          </p>
        </div>
        <Button onClick={onClick} size="lg">
          {t('personalAccount.accountsSection.emptyStateButton')}
        </Button>
      </CardContent>
    </Card>
  );
};

export { AssetsListEmptyState };
